(() => {
  angular
    .module('complianceFrameworkApp')
    .constant('config', config());

  function config() {
    return {
      complianceFrameworkApiEndpoint: 'https://compliance.temenos.com/api/compliance_framework',
      complianceServicesApiEndpoint: 'https://compliance.temenos.com/api/compliance_services',
      complianceForumsApiEndpoint: 'https://compliance.temenos.com/api/compliance_forums',
      vmsApiEndpoint: 'https://compliance.temenos.com/api/vms'      
    };
  }
})();
